import { constants } from '@hero/configs';

function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

function checkIsValidForCustomEditor(text) {
  const isEmpty = !text || text?.trim().length === 0 || text?.replace(/\n/g, '').length === 0;
  if (isEmpty) return false;

  const maxLines = 6;
  const maxLength = constants?.general?.giftMessageLimit + maxLines - 1;
  const maxLineLength = 30;

  if (text.length > maxLength) return false;

  const lines = text.split('\n');
  if (lines.length > maxLines) return false;

  for (let i = 0; i < lines.length; i++) {
    if (lines[i].length > maxLineLength) return false;
  }

  return true;
}

function getStripedValue(value) {
  if (typeof value === 'string') {
    return value.replace(/<[^>]*>?/gm, '').replace(/\n/g, '');
  }
  return '';
}

export { capitalize, checkIsValidForCustomEditor, getStripedValue };
